import http from '../common/http'

export const findAll = (param) =>{
  return http.requestPost('/procNodes/findAll',param);
}


